export enum ScrollDirectionEnum {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  BOTH = 'both',
  NONE = 'none'
}

export type ScrollDirectionEnumValues = `${ScrollDirectionEnum}`;
